export enum Address {
  Null = '0x0000000000000000000000000000000000000000',
}

export enum WithdrawalTypes {
  Investment = 'investment',
  Yield = 'yield',
}
